module.exports = __webpack_public_path__ + "img/Inflammation-PRCA_10X_ANS.82a7e44a.png";